import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, input, output, signal } from '@angular/core';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  animations: [
    trigger('iconRotate', [
      state('expanded', style({ transform: 'rotate(180deg)' })),
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      transition('expanded <=> collapsed', animate('300ms ease-in-out'))
    ])
  ]
})
export class ExpansionPanelComponent {
  title = input<string>();
  border = input<'full' | 'bottom'>('full');
  color = input<UiPalette>('primary');
  expanded = input<boolean>();

  expand = output<boolean>();

  expanded$ = signal<boolean>(false);

  faChevronDown = faChevronDown;
}
